import MeasureDescription from './MeasureDescription';

export default MeasureDescription;
